import debounce from "lodash.debounce";
import "featherlight/src/featherlight.js";

(function ($) {
  $(function () {
    var journalBuyBtns = $(".js-submit-journal");
    var inputDebounceWait = 200;

    if (journalBuyBtns) {
      journalBuyBtns.each(function (index) {
        var $this = $(this),
          foxyParams = $this.data("foxyparams"),
          $inputField = $this
            .parents(".journal-retailer")
            .find(".js-journal-issue");

        $inputField.on(
          "input",
          debounce(function (e) {
            e.preventDefault();
            var $input = $(this),
              val = $(this).val();

            $.ajax({
              url: universityPressThemeSettings.wordpressAjaxUrl,
              type: "POST",
              async: false,
              data: {
                action: "journal_btn_ajax",
                foxyParams: foxyParams,
                journal_issue: val,
                nonce: universityPressThemeSettings.ajaxNonce,
              },
              success: function (url) {
                if (!url) return;
                var $parentBuyBtn = $input
                  .parents(".journal-retailer")
                  .find(".journal-retailer__button");
                $parentBuyBtn.attr("href", url);
              },
            });
          }, inputDebounceWait),
        );
      });
    }
    $(".book-wrapper__top-section--image [data-lightbox]").on(
      "click",
      function (e) {
        e.preventDefault();
        $.featherlight($(".journal-subscribe-modal"), {
          afterOpen: function () {
            var journalSubscriptions = this.$content.find(".journal-retailer");

            journalSubscriptions.each(function () {
              var $this = $(this);
              $this.find("a, input").removeAttr("tabindex");

              $this.find(".js-journal-issue").on("input", function () {
                var $this = $(this),
                  val = $(this).val(),
                  orderField = $this.parent().prev().find(".js-submit-journal");

                if (val !== "") {
                  orderField.removeClass("disabled");
                } else {
                  orderField.addClass("disabled");
                }
              });
            });
          },
        });
      },
    );
  });
})(jQuery);
